module.exports = __webpack_public_path__ + "img/icon-dexsafe.0ca3eaec.svg";